import * as types from "./types";
import { OrderService } from "../../services/order.service";
import { getNavTabModule } from "../../../../dt-plugins/sidewindow/nav-tab";
import { dispatch } from "ramda-adjunct";
import { setMainNavInactive } from "../../../../store/app/mutations";
import { MHTTPCL } from "../../../../services/http/http-client";
import router from '../../../../router';
import { fetchPropertiesWithArgs } from '../../../../utility/fp';
import { EOL_REACHED } from "../../../../dt-plugins/advanced-search/load.model";

const NavTabModule = getNavTabModule(types.DistributionOrderDetails, 'distributionOrderDetails');

export const distributionOrderActions = {
  async [types.DistributionOrderList.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    // const orderData = await OrderService.getOrderList();
    // console.log("Log: orderData", orderData);

    // commit(types.DistributionOrderList.SET.ALL, orderData.data.orders);
    const { start, row_count, searchMode, basicFilter, searchFilter } = payload;


    let res;
    console.log("PAYLOAD:::", payload);

    if (searchMode === 'none') {
      if (start === 0) {
        //NOTE: order_types is not needed here, its static and coming from state
        
        // const typeRes = await OrderService.order_details_tab_overview();
        
        // console.log(":::RES:::", typeRes)

        res = await HttpClient.mergeRequests([
          OrderService.getOrderList(),
        ]);

        console.log("RES:::", res)

        commit(types.DistributionOrderList.SET.ALL, { ...res });  // <-- Directly Set the Data. Depends on your particular Logic
      } else {                // <-- Pagination Logic
        res = await OrderService.getFilteredOrderList({ ...basicFilter, start })    // <-- Pagination Logic
        console.log("PAYLOAD:::::::::::::", res);
        // console.log("res",res)

        commit(types.DistributionOrderList.SET.ALL, { // <-- Set the Data. Here the actual List is nested. Depends on your particular case
          ...getters.distributionOrderList,
          orders: [
            ...getters.distributionOrderList.orders,
            ...res.data.orders, // <-- append new Fetched List
          ]
        });

        // Setting EOL
        if (!(res?.data?.orders?.length > 0)) {
          return EOL_REACHED;
        }
      }

    } else if (searchMode === 'basic') {    

      res = await OrderService.getFilteredOrderList({ ...basicFilter });

      commit(types.DistributionOrderList.SET.ALL, {
        ...getters.distributionOrderList,
        orders: [
          // ...getters.distributionOrderList.orders,
          ...res.data.orders,
        ]
      });

      console.log("Search res", res.data.orders)
      if (start === 0) {
        commit(types.DistributionOrderList.SET.ALL, {
          ...getters.distributionOrderList,
          orders: res.data.orders
        });
      } else {
        commit(types.DistributionOrderList.SET.ALL, {
          ...getters.distributionOrderList,
          orders: [
            ...getters.distributionOrderList.orders,
            ...res.data.orders,
          ]
        });
      }
      // Setting EOL
      if (!(res?.data?.orders?.length > 0)) {
        return EOL_REACHED;
      }
    } else if (searchMode === 'advanced') {
      // console.log({ "searchFilter": searchFilter });

     //  account_id=279
     //  status=to+prepare
     //  order_month=2023-09
     //  accounted_period=current_day
     //  order_date_start=2024-02-16
     //  order_date_end=2024-02-16
     //  shipping_date=2024-02-07
     //  is_shipped=shipped
     //  order_reference=653674727513+
     //  filterEmpty=false
     //  start=-1
     //  action=filter_order_list
     //  edicot_only=
     //  section=orders
    
      res = await OrderService.getFilteredOrderList({
        ...searchFilter,
        start: searchFilter.start || -1
      })

      if (start === 0) {
        commit(types.DistributionOrderList.SET.ALL, {
          ...getters.distributionOrderList,
          orders: res.data.orders
        });
      } else {
        commit(types.DistributionOrderList.SET.ALL, {
          ...getters.distributionOrderList,
          orders: [
            ...getters.distributionOrderList.orders,
            ...res.data.orders,
          ]
        });
      }
      // Setting EOL
      if (!(res?.data?.orders?.length > 0)) {
        return EOL_REACHED;
      }
    }

    //const statementOverviewData = await HttpClient.mergeRequests(promises);

    //console.log("StatementOverviewData",statementOverviewData);

    //commit(types.BelieveStatementList.SET.ALL,  statementOverviewData );



  },
  async [types.DistributionOrderList.SET.ALL]({ commit, getters }, payload) {
    const {orders}=payload;
    commit(types.DistributionOrderList.SET.ALL, {
      ...getters.distributionOrderList,
      orders: orders,

    });

  },
  async [types.DistributionOrderList.UPDATE.SINGLE]({ commit, getters }, payload) {
    const { item, name, value } = payload;
    // Different update process for main_contact_id
    // const key =
    //   [
    //     'notes',
    //     'main_contact_id',
    //     'url1',
    //     'url2',
    //     'url3',
    //     'cost_center',
    //     'default_agent_commission'
    //   ].includes(name) ? 'order_id' : 'order_id';

    const key = 'order_id';

    const kVal = item[key];
    const table = 'l_orders';

    // Updatring the Order List - By the individual Order Data Update
    commit(types.DistributionOrderList.SET.ALL, {
      ...getters.distributionOrderList,
      orders: getters.distributionOrderList?.orders.map(a => {
        if (a.order_id == kVal) {
          return {
            ...a,
            [name]: value
          };
        } else {
          return a;
        }
      })
    });

    const updateSelectedOrder = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table,
    );
  },

  async [types.DistributionOrderList.SET.SINGLE]({ commit, getters }, payload) {
    console.log(":::::::", payload)
    commit(types.DistributionOrderList.SET.ALL, {
      ...getters.distributionOrderList,
      bandCampResponse: {
        ...payload
      }
    });
  },


  async [types.DistributionOrderList.INSERT.SINGLE]({ commit, getters }, payload) {
    const accountData = await OrderService.addOrder(payload);
    console.log("ACTION:::::", accountData)
    commit(types.DistributionOrderList.SET.ALL, {
      ...getters.distributionOrderList,
      orders: [
        ...accountData.data.orders.sort((a, b) => a.order_id < b.order_id)
      ]
    });

    return accountData.data.orders.sort((a, b) => a.order_id < b.order_id)[0]
  },

  async [types.DistributionOrderList.DELETE.SINGLE]({ commit, getters }, payload) {
    const { order_id } = payload
    const accountData = await OrderService.deleteOrder({ order_id });
    //console.log("ACTION:::::",accountData)
    commit(types.DistributionOrderList.SET.ALL, {
      ...getters.distributionOrderList,
      orders: [
        ...getters.distributionOrderList.orders.filter(x => x.order_id != order_id)
      ]
    });
  },

  async [types.DistributionOrderDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, order, reload } = payload;


    flag = typeof flag === 'boolean' ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = 'order_id';
    const itemName = 'order';
    const item = payload[itemName];
    console.log({ 'actions.js:195 payload[itemName]': payload[itemName] });


    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = 'distributionOrderDetails';
    const DetailsAction = types.DistributionOrderDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true,

        contact_loading: true,
      }
    })


    await dispatch(types.DistributionOrderDetails.FETCH.PARTIAL, {
      properties: [
        'order_details_tab_summary',
        'get_delivery_address',
        'get_backorders',
        'packing_orderlines',


        // Only needed for Contact_ID field ... It seems
        'order_details',

        // Only Needed for internal_notes it seems
        // Now that's Available in the Order Details Tab Summary
        // No Need for orderline_pack_status
        'order_details_tab_packing_shipping',

        // 'order_details_tab_overview',
        // 'order_details_tab_orderlines',
        // 'get_orderlines',

        // 'order_details',
        // 'order_details_tab_overview',
        // 'order_details_tab_summary',
        // 'get_delivery_address',
        // 'get_backorders',
        // 'order_details_tab_orderlines',
        // 'get_orderlines',
        // 'order_details_tab_packing_shipping',
        // 'packing_orderlines',
      ], order_id: order.order_id,
      parallel: false,
    });



    // HTTP Req
    // const detailsData = await HttpClient.mergeRequests([
    //   OrderService.order_details(order.order_id),
    //   OrderService.order_details_tab_overview(order.order_id),
    //   OrderService.order_details_tab_summary(order.order_id),
    //   OrderService.get_delivery_address(order.order_id),
    //   OrderService.get_backorders(order.order_id),
    //   OrderService.order_details_tab_orderlines(order.order_id),
    //   OrderService.get_orderlines(order.order_id),
    //   OrderService.order_details_tab_packing_shipping(order.order_id),
    //   OrderService.packing_orderlines(order.order_id),
    // ]);
    // Previously Part of DetailsData mergeRequests
    //OrderService.getContactByOrderId(order.contact_id),


    const contact_id = getters?.[detailsGetterKey]?.[primaryKeyValue]?.order_details_tab_summary?.order?.contact_id;
    console.log({ 'actions.js:265 contact_id': contact_id });
    const contact = await OrderService.getContactByOrderId(contact_id);
    console.log("getContactByOrderId::contact", contact);

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, order) => {
      return {
        ...order,
        contact: contact.data.contact,
        contact_loading: false,
      }
    });
  },
  async [types.DistributionOrderDetails.FETCH.PARTIAL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { properties, order_id, parallel, setnull } = payload;

    await fetchPropertiesWithArgs(NavTabHelper, OrderService, properties, [order_id], parallel, setnull);
  },


  ...NavTabModule.implementActions(
    'order_id',
    'orders/order_id/tab',
    'orders',
    () => router,
    'distribution',
    (value, key) => {
      console.log("value, key::::", value, key)
      return {
        title: (value && value.order && value.order.order_type_name) ? `${key} ${value.order.order_type_name}` : key,
        full_title: (value && value.order && value.order.order_type_name) ? `${key} ${value.order.order_type_name}` : key
      }
    }
  ),
  async [types.DistributionOrderDetails.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log("types.ReleaseDetails.UPDATE.SINGLE", payload)


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name, value, order_id, kVal } = payload
    // const { order } = item;
    // const { order_id } = order;


    //console.log("types.ReleaseDetails.UPDATE.SINGLE", name, value, item)
    NavTabHelper.updateSingleNavTabDetails(order_id, (oldOrder) => {
      let order_type_name;

      // If name is order_type also update the order_type_name
      if (name == 'order_type') {
        order_type_name = oldOrder?.order_details_tab_summary?.order_types?.find((order_type) => order_type.value == value)?.label;
      }

      return {
        order_details_tab_summary: {
          ...oldOrder.order_details_tab_summary,
          order: {
            ...oldOrder.order_details_tab_summary.order,
            [name]: value,
            ...(order_type_name && { order_type_name })
          }
        }
      }
    });
    // const modifiedOrder= await MHTTPCL.modifyJSON("",order_id,name,value,"l_orders");

    if (kVal) {
      await OrderService.modifyVatTerritory(order_id, value);
    } else {
      if (name == 'status_name') {
        await OrderService.modifyOrder(order_id, 'status', value, 'l_orders');
      } else {
        await OrderService.modifyOrder(order_id, name, value, 'l_orders');
      }
    }


    // If the Field affects the Other Fields, Should be Refetched

    if (['order_discount'].includes(name)) {
      // Refetching the Order Details
      dispatch(types.DistributionOrderDetails.FETCH.PARTIAL, {
        properties: [
          'order_details_tab_summary',
        ], order_id: order_id,
        parallel: false,
      });
    }



  },
  async [types.DistributionOrderInvoiceContact.SET.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("payload::::", payload)

    const { external_id, item_contact } = payload;

    NavTabHelper.updateSingleNavTabDetails(external_id, (_, oldOrder) => {
      return {
        ...oldOrder,
        contact: item_contact
      };
    })
  },

  async [types.DistributionOrderDeliveryAddress.SET.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("payload::::", payload)
    const { contact_id, order_id } = payload;

    const deliveryInfo = await OrderService.editOrderDeliveryInfo(order_id, contact_id);
    console.log("DELIVERY INFO", deliveryInfo.data);
    NavTabHelper.updateSingleNavTabDetails(order_id, (oldOrder) => {
      return {
        order_details_tab_summary: {
          ...oldOrder.order_details_tab_summary,
          order: {
            ...oldOrder.order_details_tab_summary.order,
            ...deliveryInfo.data,
          }
        }
      }
    });
  },

  async [types.DistributionOrderBackOrder.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, item, order } = payload;
    const { order_id } = order;

    const key = 'backorder_id';
    const kVal = item[key];
    const table = 'l_backorders';


    NavTabHelper.updateSingleNavTabDetails(order_id, (oldOrder) => {
      return {
        get_backorders: {
          ...oldOrder.get_backorders,
          backorders: oldOrder?.get_backorders?.backorders?.map(e => {
            if (e.backorder_id == item.backorder_id) {
              return {
                ...e,
                [name]: value,
              };
            } else {
              return e;
            }
          })
        }
      }
    })

    const modifiedOrder = await OrderService.modifyOrder(kVal, name, value, table);
  },

  async [types.DistributionOrderBackOrder.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { order_id, item } = payload;

    NavTabHelper.updateSingleNavTabDetails(order_id, (oldOrder) => {
      return {
        get_backorders: {
          ...oldOrder.get_backorders,
          backorders: oldOrder?.get_backorders?.backorders.filter(e => e.backorder_id != item.backorder_id)
        }
      }
    })
    // const deleteOrderLine= await OrderService.deleteOrderLine({orderline_id:item.orderline_id,order_id:order_id})


  },
  async [types.DistributionOrderBackOrder.UPDATE.MULTIPLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { order_id, backorders } = payload;

    const resBackOrdersData = await OrderService.addBackorders({ backorders, order_id });

    // const resOrderLinesData = await OrderService.get_orderlines(order_id);

    // const resPackageOrderLinesData = await OrderService.packing_orderlines(order_id);

    NavTabHelper.updateSingleNavTabDetails(order_id, (oldOrder) => {
      return {
        ...oldOrder,
        get_backorders: {
          ...oldOrder.get_backorders,
          backorders: resBackOrdersData.data.backorders,
        },
        // order_details_tab_summary: {
        //   ...oldOrder.order_details_tab_summary,
        //   orderlines: resOrderLinesData.data.orderlines
        // },
        // packing_orderlines: {
        //   ...oldOrder.packing_orderlines,
        //   package_orderlines: resPackageOrderLinesData.data.package_orderlines
        // }
      }
    });
  },

  async [types.DistributionOrderOrderLine.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    // console.log("PAYLOAD::::",payload)
    const { order_id } = payload;
    // const insertedOrderline= await OrderService.addProdctsToOrder({...payload});

    const orderLines = await OrderService.get_orderlines(order_id)

    console.log("NEW ORDERLINE", orderLines.data.orderlines);

    NavTabHelper.updateSingleNavTabDetails(order_id, (oldOrder) => {
      return {
        order_details_tab_summary: {
          ...oldOrder?.order_details_tab_summary,
          orderlines: orderLines.data.orderlines
        }
      }
    })
  },

  async [types.DistributionOrderOrderLine.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    console.log("PAYLOAD::::", payload)
    const { name, value, item, order } = payload;
    const { order_id } = order;

    const key = 'orderline_id';
    const kVal = item[key];
    const table = 'l_orderlines';

    // const oldValue = item[name];
    // if (oldValue == value) {
    //   return;
    // }


    NavTabHelper.updateSingleNavTabDetails(order_id, (oldOrder) => {
      return {
        order_details_tab_summary: {
          ...oldOrder.order_details_tab_summary,
          orderlines: oldOrder.order_details_tab_summary.orderlines.map(e => {
            if (e.orderline_id == item.orderline_id) {
              return {
                ...e,
                [name]: value,
              };
            } else {
              return e;
            }
          })
        }
      }
    })

    const modifiedOrder = await OrderService.modifyOrder(kVal, name, value, table);


    // Refetch order_details_tab_summary
    await dispatch(types.DistributionOrderDetails.FETCH.PARTIAL, {
      order_id: order_id,
      properties: [
        'order_details_tab_summary',
        'packing_orderlines'
      ],
    });
  },

  async [types.DistributionOrderOrderLine.INSERT.MULTIPLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    console.log("PAYLOAD::::", payload)
    const { order_id } = payload;
    const insertedOrderline = await OrderService.addProdctsToOrder({ ...payload });

    // const orderLines = await OrderService.loadOrderOrderlines(order_id);

    NavTabHelper.updateSingleNavTabDetails(order_id, (oldOrder) => {
      return {
        orderlines: [...orderLines.data.orderlines]
      }
    })
  },

  async [types.DistributionOrderOrderLine.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { order, item } = payload;
    const { order_id } = order;

    NavTabHelper.updateSingleNavTabDetails(order_id, (oldOrder) => {
      return {
        order_details_tab_summary: {
          ...oldOrder.order_details_tab_summary,
          orderlines: oldOrder.order_details_tab_summary.orderlines.filter(e => e.orderline_id != item.orderline_id)
        },
      }
    })
    await OrderService.deleteOrderLine({ orderline_id: item.orderline_id, order_id: order_id });

    // Refetch order_details_tab_summary
    await dispatch(types.DistributionOrderDetails.FETCH.PARTIAL, {
      order_id: order_id,
      properties: [
        'order_details_tab_summary',
      ],
    });
  },

  async[types.DistributionOrderOrderLine.UPDATE.MULTIPLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    console.log("PAYLOAD::::", payload)
    const { order_id, price_codes } = payload;

    const updatedDiscount = await OrderService.udpatePriceCodeDiscount({ ...payload });
    const orderLines = await OrderService.loadOrderOrderlines(order_id);

    NavTabHelper.updateSingleNavTabDetails(order_id, (oldOrder) => {
      return {
        order_details_tab_summary: {
          ...oldOrder.order_details_tab_summary,
          orderlines: orderLines.data.orderlines
        }
      }
    })



  },


  async[types.DistributionPackageLine.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    // console.log("PAYLOAD::::",payload)
    const { order_id, status = "" } = payload;
    // const insertedOrderline= await OrderService.addProdctsToOrder({...payload});

    const orderLines = await OrderService.packing_orderlines(order_id, `${status}`)

    console.log("NEW PACKAGELINE", orderLines.data.orderlines);


    NavTabHelper.updateSingleNavTabDetails(order_id, (oldOrder) => {
      return {
        packing_orderlines: {
          orderlines: orderLines.data.orderlines
        },
        order_details_tab_packing_shipping: {
          ...oldOrder?.order_details_tab_packing_shipping,
          orderline_pack_status_value: status
        }
      }
    })


  },
  async[types.DistributionPackageLine.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, item, order } = payload;
    const { order_id } = order;

    const key = 'orderline_id';
    const kVal = item[key];


    NavTabHelper.updateSingleNavTabDetails(order_id, (oldOrder) => {
      return {
        packing_orderlines: {
          ...oldOrder.packing_orderlines,
          orderlines: oldOrder?.packing_orderlines?.orderlines.map(e => {
            if (e.orderline_id == item.orderline_id) {
              if (name == 'shortfall_qty') {
                return {
                  ...e,
                  [name]: value,
                  backorder_flag: value > 0 ? 'BO' : '',
                  qty: value > 0 ? +e.order_qty - +value : +e.order_qty,
                };
              }
              else {
                return {
                  ...e,
                  [name]: value,
                };
              }
            } else {
              return e;
            }
          }),
        }
      }
    })
    const modifiedOrder = await OrderService.modifyShortfallQty(item.orderline_id, value);

    // Refetch order_details_tab_summary & packing_orderlines
    await dispatch(types.DistributionOrderDetails.FETCH.PARTIAL, {
      order_id: order_id,
      properties: [
        'order_details_tab_summary',
        'packing_orderlines',
      ],
    });

  },

  async[types.DistributionShippingSummary.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log("UPDATE.SINGLE", payload)


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name, value, item } = payload
    const { order } = item;
    const { order_id } = order;


    console.log("UPDATE.SINGLE", name, value, item)
    NavTabHelper.updateSingleNavTabDetails(order_id, (oldOrder) => {
      console.log("OLDORDER::::::::", oldOrder);
      return {
        order_details_tab_summary: {
          ...oldOrder.order_details_tab_summary,
          order: {
            ...oldOrder?.order_details_tab_summary?.order,
            [name]: value,
          }
        },
      }
    });

    const modifiedOrder = await OrderService.modifyOrder(order_id, name, value, 'l_orders');


    if (['shipping_costs'].includes(name)) {
      // Refetching the Order Details
      dispatch(types.DistributionOrderDetails.FETCH.PARTIAL, {
        properties: [
          'order_details_tab_summary',
        ], order_id: order_id,
        parallel: false,
      });
    }
  },

  async[types.DistributionShippingSummary.UPDATE.MULTIPLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { order_id, orderlines, status } = payload;

    // const orderlinesIDArray=orderLines.map(e=>{
    //   return{
    //     orderline_id:e.orderline_id
    //   }
    // });

    //const resOrderLinesData = status ? await OrderService.updatePickStatus({ order_id, status, orderlines }) : await OrderService.autoBackorderFromPacking(order_id, orderlines);

    if (status) {
      await OrderService.updatePickStatus({ order_id, status, orderlines })
    } else {
      await OrderService.autoBackorder(order_id);
    }
    await dispatch(types.DistributionOrderDetails.FETCH.PARTIAL, {
      order_id: order_id,
      properties: [
        'order_details_tab_summary',
        'packing_orderlines',
      ],
    });
    // NavTabHelper.updateSingleNavTabDetails(order_id, (oldOrder) => {
    //   return {
    //     packing_orderlines: null,
    //     packing_orderlines_loading: true,
    //   }
    // });


    // const packing_orderlinesRes = await OrderService.packing_orderlines(order_id);

    // console.log("DistributionShippingSummary.UPDATE.MULTIPLE::::", packing_orderlinesRes)
    // NavTabHelper.updateSingleNavTabDetails(order_id, (oldOrder) => {
    //   return {
    //     packing_orderlines_loading: false,
    //     packing_orderlines: packing_orderlinesRes.data,
    //   }
    // });

    // const modifiedOrder =await OrderService.modifyOrder(order_id,name,value,'l_orders');
  },








};
